import styled from "@emotion/styled";
import { formatColumnsAsStyles } from "../particle";
var RichTextWrapper = /*#__PURE__*/ styled("div", {
    target: "e10etap20"
})(function(param) {
    var rules = param.rules;
    var ref;
    return (ref = rules.columns) === null || ref === void 0 ? void 0 : ref.map(formatColumnsAsStyles);
}, ";");
export { RichTextWrapper };
